import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VerificationSource } from '../../models/verification.model';
import {
  VERIFICATION_FEATURE_KEY,
  VerificationState,
} from './verification.reducer';

export const selectVerificationState = createFeatureSelector<VerificationState>(
  VERIFICATION_FEATURE_KEY
);

export const selectVerificationActionId = createSelector(
  selectVerificationState,
  state => state.actionId
);

export const selectVerificationMethod = createSelector(
  selectVerificationState,
  state => state.method
);

export const selectVerificationExpiresAt = createSelector(
  selectVerificationState,
  state => state.expiresAt
);

export const selectVerificationSource = createSelector(
  selectVerificationState,
  state => state.source
);

export const selectVerificationSubmitting = createSelector(
  selectVerificationState,
  state => state.submitting
);

export const selectVerificationError = createSelector(
  selectVerificationState,
  state => state.error
);

export const selectVerificationAttemptsRemaining = createSelector(
  selectVerificationState,
  state => state.attemptsRemaining
);

/** True once the backend has locked the handle; the modal should offer a restart, not another try. */
export const selectVerificationLocked = createSelector(
  selectVerificationState,
  state => state.locked
);

/** True when the last code was already spent on another approval; the modal counts down to the next code. */
export const selectVerificationCodeReused = createSelector(
  selectVerificationState,
  state => state.codeReused
);

/** Convenience: a challenge is active iff we hold an `actionId`. */
export const selectHasVerificationChallenge = createSelector(
  selectVerificationActionId,
  actionId => Boolean(actionId)
);

/**
 * True while the slice holds exactly this challenge — the same handle raised
 * by the same flow. Anything else (cleared, or replaced by another flow's
 * challenge) means the operator is no longer answering it (F-053, F-055).
 */
export const selectIsLiveVerificationChallenge = (
  actionId: string,
  source: VerificationSource
) =>
  createSelector(
    selectVerificationState,
    state => state.actionId === actionId && state.source === source
  );
